import enums from '@/utils/enums';
import { CONFIG } from '@/utils/constants';
import { hasPermission } from '@/utils';
import { UNIT } from '../../utils/constants';

export default {
  data() {
    // the values and typing used in here is very important for it to work,
    // check the Home.vue component for more information.
    return {
      // tourUrl: '',
      // enterpriseLastUpdate: '',
      // enterpriseStage: undefined,
      enterpriseLoading: false,
      enterpriseError: false,
      userHasPermission: true
    };
  },
  computed: {
    iframeSourceUrl() {
      return this.$store.getters[CONFIG.GET_SHARED_INTEGRATIONS]
        .INSTITUTIONAL_SITE_URL;
    },
    iframeSourceToken() {
      return this.$store.getters[CONFIG.GET_SHARED_INTEGRATIONS]
        .INSTITUTIONAL_SITE_TOKEN;
    },
    enterpriseAllowed() {
      const { excludeModules } = this.$store.getters[
        CONFIG.GET
      ].navigationRules;
      return (
        !excludeModules.find(o => o === 'enterprise') &&
        !this.isExceptionProduct &&
        this.userHasPermission
      );
    },
    enterpriseStage() {
      return this.$store.getters[UNIT.GET_SELECTED_PRODUCT]
        ? this.$store.getters[UNIT.GET_SELECTED_PRODUCT].stage
        : null;
    },
    enterpriseLastUpdate() {
      return this.$store.getters[UNIT.GET_SELECTED_PRODUCT]
        ? this.$store.getters[UNIT.GET_SELECTED_PRODUCT].externalLastUpdate ||
            this.$store.getters[UNIT.GET_SELECTED_PRODUCT].lastUpdate
        : null;
    },
    tourUrl() {
      return this.$store.getters[UNIT.GET_SELECTED_PRODUCT]
        ? this.$store.getters[UNIT.GET_SELECTED_PRODUCT].tourUrl
        : null;
    }
  },
  methods: {
    async getTourUrl() {
      try {
        if (!hasPermission(enums.enterpriseViewProfiles)) {
          this.userHasPermission = false;
          return;
        }

        this.enterpriseLoading = true;
        this.$store.dispatch(UNIT.FETCH_PRODUCT);
        // const params = {
        //     filter: {
        //         code: this.selectedUnit.product.code
        //     },
        //     desiredFields: {
        //         code: 1,
        //         tourUrl: 1,
        //         status: 1,
        //         lastUpdate: 1,
        //         stage: 1
        //     },
        // }
        // const url = `${process.env.CRUD_API_GET}/product`
        // const result = await this.requestService(url, 'GET', { params, localErrorHandling: true})

        // if (!result) this.enterpriseError = true

        // // the values and typing used in here is very important for it to work,
        // // check the Home.vue component for more information.
        // if (result.items.length > 0) {
        //     const [ item ] = result.items
        //     // this.enterpriseStage = item.stage ? item.stage : null
        //     this.tourUrl = item.tourUrl ? item.tourUrl : null
        //     this.enterpriseLastUpdate = item.lastUpdate ? item.lastUpdate : null
        // } else {
        //     this.enterpriseStage = null
        //     this.tourUrl = null
        //     this.enterpriseLastUpdate = null
        // }
      } catch (err) {
        this.enterpriseError = true;
      } finally {
        this.enterpriseLoading = false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/modules/enterprise.js